import React, { ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  description?: string;
  emoji?: string;
  actions?: ReactNode;
  className?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({ 
  title, 
  description, 
  emoji, 
  actions, 
  className = '' 
}) => {
  return (
    <div className={`bg-white rounded-lg shadow p-6 ${className}`}>
      <div className="flex items-center justify-between">
        <div>
          <div className="flex items-center space-x-2 mb-2">
            {emoji && <span role="img" aria-label={title.toLowerCase()} className="text-3xl">{emoji}</span>}
            <h1 className="text-3xl font-bold text-gray-900">{title}</h1>
          </div>
          {description && (
            <p className="text-gray-600">{description}</p>
          )}
        </div>
        {actions && <div>{actions}</div>}
      </div>
    </div>
  );
};

export default PageHeader;
